module.exports = __webpack_public_path__ + "img/hourglass-empty.16bee242.svg";